import { render } from "./customer-details-mdm.vue?vue&type=template&id=79c08b0d&scoped=true"
import script from "./customer-details-mdm.vue?vue&type=script&lang=js"
export * from "./customer-details-mdm.vue?vue&type=script&lang=js"

import "./customer-details-mdm.vue?vue&type=style&index=0&id=79c08b0d&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c08b0d"]])

export default __exports__